<template>
    <div class="window-wrapper window-mail-draft-delete">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Вы действительно хотите удалить черновик письма?</div>
                    <div class="button-block">
                        <button @click="confirmDelete" class="button button-dark button-close-window">Да</button>
                        <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DeleteDraftWindow",
        methods: {
            confirmDelete() {
                this.$emit("confirmDelete");
                this.closeWindow();
            },
            closeWindow() {
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            }
        }
    }
</script>

<style scoped>

</style>